import { ApiEndpointBuilder } from "@/services/api/types";
import { PlanType } from "../types";

const getAllPlans = (builder: ApiEndpointBuilder) => {
  return builder.query<PlanType[], void>({
    query: () => ({
      url: `/checkout/prices`,
      method: "GET",
    }),
  });
};
export default getAllPlans;
